const LEGACY_RANK_TYPE_TO_CODE: Record<string, string> = {
  '4': 'RECOMMEND',
  '1': 'NEW',
  '2': 'HOT'
};

export const normalizeRankCode = (type?: number | string | null): string => {
  if (type === undefined || type === null || type === '') return 'RECOMMEND';

  const rankType = String(type);
  return LEGACY_RANK_TYPE_TO_CODE[rankType] || rankType;
};
